module.exports = __webpack_public_path__ + "static/media/Improperlogo.5d8b2c4d.png";